module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gw60E"))).then(() => module.bundle.root('d0iPb'));